import React from 'react'
import pdfLogo from 'images/pdf-logo.png'
import logoAmazon from 'images/icons/amazon.svg'
import logoGoogle from 'images/icons/google.svg'
import logoYoutube from 'images/icons/youtube.svg'
import bg from 'images/personas/bg-category.jpg'
import LimitedViewText from './LimitedViewText'

const SERP = ({
  amazon,
  google,
  industry,
  limitedView,
  photo,
  youtube,
}) => {
  const maxRows = 5

  const content = (
    <React.Fragment>
      <div className="flex mb2">
        <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
        <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
        <div className="border border-violet-red bw-2 mr2 rounded-6" style={{ height: 20, width: 20 }} />
        <div className="bg-violet-red mr2 rounded-6" style={{ height: 20, width: 20 }} />
      </div>

      <h2 className="persona-sub-title mb3">Content they are exposed</h2>

      <p className="h2 mb4 x-lg-h3 x-lg-mb3">When your audience searches for your category here ae the top results they are served with</p>

      <div className="flex flex-wrap">
        <div className="col-4 flex pdf-hide sm-col-12">
          <div className="image-layer image-layer--black bg-center bg-cover bg-no-repeat col-12 flex p3 relative text-white" style={{ backgroundImage: `url(${photo.length > 0 ? photo[0].url : bg})` }}>
            <div className="relative z1">
              <p className="h3 text-upper">Category</p>
              <p className="fs-48">{industry.label}</p>
            </div>
          </div>
        </div>

        <div className="col-8 flex pdf-col-12 sm-col-12">
          <div className="table-outer-container col-12">
            <div className="table-container">
              <table className="persona-table h5 pdf-fs-12 pdf-serp-table-max-width">
                <tbody>
                  <tr>
                    {google.length > 0 && <td style={{ borderBottom: 0, padding: '8px 10px' }}>
                      <img alt="Google" className="block mx-auto" src={logoGoogle} style={{ height: 30 }} />
                    </td>}

                    {amazon.length > 0 && <td style={{ borderBottom: 0, padding: '8px 10px' }}>
                      <img alt="Amazon" className="block mx-auto" src={logoAmazon} style={{ height: 30 }} />
                    </td>}

                    {youtube.length > 0 && <td style={{ borderBottom: 0, padding: '8px 10px' }}>
                      <img alt="Youtube" className="block mx-auto" src={logoYoutube} style={{ height: 30 }} />
                    </td>}
                  </tr>

                  {[...Array(maxRows)].map((item, index) => (
                    <tr>
                      {google[index] && <td className="col-4 pdf-col-25p">{limitedView ? <LimitedViewText short /> : <a className="underline" target="_blank" href={google[index].url}>{google[index].title}</a>}</td>}
                      {amazon[index] && <td className="col-4 pdf-col-50p">{limitedView ? <LimitedViewText short /> : <a className="underline" target="_blank" href={amazon[index].url}>{amazon[index].title}</a>}</td>}
                      {youtube[index] && <td className="col-4 pdf-col-25p">{limitedView ? <LimitedViewText short /> : <a className="underline" target="_blank" href={youtube[index].url}>{youtube[index].title}</a>}</td>}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );

  return (
    <React.Fragment>
      <section className="section" data-anchor="serp">
        <div className="slider-box slider-box--pdf-p0 bg-white box-shadow-box flex flex-wrap sm-block">
          <div className="col-12 p3 sm-p0">
            {content}
          </div>
        </div>
      </section>
    </React.Fragment>
  )
};

export default SERP
